import {Inject, Injectable, LOCALE_ID} from '@angular/core';
import {isEmptyOrUndefined, trimFirstToken} from '@app/shared/util/string-util';
import {Location} from '@angular/common';

const apiPrefixSegments = ['api'];

@Injectable({
	providedIn: 'root'
})
export class UrlHelperService {
	readonly #languageCode: string;

	constructor(private location: Location, @Inject(LOCALE_ID) locale: string) {
		this.#languageCode = locale.substring(0, 2).toLowerCase();
	}

	prepareApiPath(...segments: string[]): string {
		const baseUrl = this.getNonLocalizedBasePath();
		const prefixedSegments = [baseUrl, ...apiPrefixSegments, ...segments];
		return `/${prefixedSegments
			.map(segment => trimFirstSlashIfPresent(segment))
			.filter(segment => segment.length > 0)
			.join('/')}`;
	}

	getNonLocalizedBasePath(): string {
		const baseUrl = this.location.prepareExternalUrl('');
		return baseUrl
			.replace(new RegExp(`/${this.#languageCode}/?$`), '');
	}
}

function trimFirstSlashIfPresent(urlSegment: string): string {
	return isEmptyOrUndefined(urlSegment) ? urlSegment : trimFirstToken(urlSegment, '/');
}
